module.exports = __webpack_public_path__ + "img/_3.10871ccf.png";